import { LeadResponse } from '@/types/api';
import { leadsLogger } from '@/utils/logger';

/**
 * Obtém o número de telefone do lead, considerando os diferentes campos possíveis
 * @param lead - Dados do lead
 * @returns Número de telefone ou null se não encontrado
 */
export const getLeadPhoneNumber = (lead: LeadResponse | null | undefined): string | null => {
  if (!lead) {
    leadsLogger.log('getLeadPhoneNumber: lead é null/undefined');
    return null;
  }
  
  leadsLogger.log('getLeadPhoneNumber - Lead:', lead);
  leadsLogger.log('getLeadPhoneNumber - waId:', lead.waId);
  leadsLogger.log('getLeadPhoneNumber - phone:', lead.phone);
  
  // Priorizar waId (WhatsApp ID) que é o campo real do backend
  if (lead.waId && lead.waId.trim().length > 0) {
    return lead.waId;
  }
  
  // Fallback para phone se existir
  if (lead.phone && lead.phone.trim().length > 0) {
    return lead.phone;
  }
  
  return null;
};

/**
 * Formata um número de telefone para exibição
 * @param phone - Número de telefone
 * @returns Número formatado ou mensagem padrão
 */
export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) return "Telefone não informado";
  
  // Remove caracteres não numéricos
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Formatar telefone brasileiro
  if (cleanPhone.length === 11) {
    // Celular: (11) 99999-9999
    return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 7)}-${cleanPhone.slice(7)}`;
  } else if (cleanPhone.length === 10) {
    // Fixo: (11) 9999-9999
    return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 6)}-${cleanPhone.slice(6)}`;
  } else if (cleanPhone.length === 13 && cleanPhone.startsWith('55')) {
    // Com código do país: +55 (11) 99999-9999
    const withoutCountry = cleanPhone.slice(2);
    return `+55 (${withoutCountry.slice(0, 2)}) ${withoutCountry.slice(2, 7)}-${withoutCountry.slice(7)}`;
  } else if (cleanPhone.length === 12 && cleanPhone.startsWith('55')) {
    // Com código do país sem 9: +55 (11) 9999-9999
    const withoutCountry = cleanPhone.slice(2);
    return `+55 (${withoutCountry.slice(0, 2)}) ${withoutCountry.slice(2, 6)}-${withoutCountry.slice(6)}`;
  }
  
  // Se não conseguir formatar, retorna o número original
  return phone;
};

/**
 * Obtém e formata o telefone do lead para exibição
 * @param lead - Dados do lead
 * @returns Telefone formatado ou mensagem padrão
 */
export const getFormattedLeadPhone = (lead: LeadResponse | null | undefined): string => {
  leadsLogger.log('getFormattedLeadPhone - Input lead:', lead);
  
  const phone = getLeadPhoneNumber(lead);
  leadsLogger.log('getFormattedLeadPhone - Extracted phone:', phone);
  
  const formatted = formatPhoneNumber(phone);
  leadsLogger.log('getFormattedLeadPhone - Formatted result:', formatted);
  
  return formatted;
};
